import { render, staticRenderFns } from "./ViewGradeCategory.vue?vue&type=template&id=1bf76577&scoped=true"
import script from "./ViewGradeCategory.vue?vue&type=script&lang=js"
export * from "./ViewGradeCategory.vue?vue&type=script&lang=js"
import style0 from "./ViewGradeCategory.vue?vue&type=style&index=0&id=1bf76577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf76577",
  null
  
)

export default component.exports